import { render, staticRenderFns } from "./LiveCountdown.vue?vue&type=template&id=af3f9030&"
import script from "./LiveCountdown.vue?vue&type=script&lang=js&"
export * from "./LiveCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports